import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};
export const accordionSummary: SxStyle = {};

export const answer: SxStyle = {
  fontSize: (p) => p.typography.caption,
  fontWeight: 400,
  textAlign: 'start',
};
